module.exports = __webpack_public_path__ + "static/img/weather01.a52608b0.png";